import { keyframes } from '@chakra-ui/react';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
let Spinner = {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "var(--spinner-color, var(--vimeo-colors-blue-500))",
    height: "var(--spinner-size)",
    width: "var(--spinner-size)",
    animation: `${spin} var(--spinner-timing, 800ms) linear infinite`
  },
  sizes: {
    xl: {
      "--spinner-size": "2.5rem",
      "--spinner-border-width": "6"
    },
    lg: {
      "--spinner-size": "1.625rem",
      "--spinner-border-width": "5.5"
    },
    md: {
      "--spinner-size": "1.5rem",
      "--spinner-border-width": "4"
    },
    sm: {
      "--spinner-size": "1rem",
      "--spinner-border-width": "2"
    },
    xs: {
      "--spinner-size": "0.75rem",
      "--spinner-border-width": "2"
    }
  },
  defaultProps: {
    size: "md"
  }
};

export { Spinner };
